module.exports = __webpack_public_path__ + "static/media/brightness-half.4ecbcebd.svg";